import "./buttons.scss";

import { ReactComponent as PlusIcon } from "../icons/plusIcon.svg";

export const PlusButton = (props: {
  onClick: () => void;
  hint?: string;
}): JSX.Element => {
  return (
    <button className="plus rg-button rg-red" onClick={props.onClick} title={props.hint}>
      <PlusIcon />
    </button>
  );
};
